import { RoleRoute, RoleRouteObject, RouteFunctionParams } from '@/types'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { defer, LoaderFunction } from 'react-router-typesafe'
import TicketsPage from '@/routes/tickets/TicketsPage'
import TicketCreatorRoute from '@/routes/tickets/TicketCreator.route'
import { stato_ticket } from '@/model/qsadminapi/QsAdminApiModuleModel'
import TicketsHistoricPageRoute from '@/routes/tickets/historic/TicketsHistoricPage.route'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { faTicket } from '@fortawesome/free-solid-svg-icons'
import TicketEditorRoute from '@/routes/tickets/TicketEditor.route'
import { TicketMasterViewRoute } from '@/routes/tickets/TicketMasterView.route'

export const activeState: stato_ticket = {
  id: 99_999,
  nome: 'ATTIVO',
  note: null,
}

export const ticketsPageRouteLoader = (async ({ request, params }: RouteFunctionParams) => {
  return defer({
    userInfo: await getAzureUserInformation(),
  })
}) satisfies LoaderFunction

export const TicketsPageRoute: RoleRoute = {
  path: 'tickets',
  children: [
    {
      index: true,
      element: <TicketsPage />,
      loader: ticketsPageRouteLoader,
      allowedRoles: [Roles.Guest],
    } as RoleRouteObject,
    TicketMasterViewRoute,
    TicketCreatorRoute,
    TicketEditorRoute,
    TicketsHistoricPageRoute,
  ],
  errorElement: <RouterErrorHandler />,
  text: 'Ticket',
  faIcon: faTicket,
  mainMenuRoute: true,
  handle: {
    crumb: () => ({
      label: 'Ticket',
      icon: faTicket,
    }),
  },
  allowedRoles: [Roles.Guest],
}
